import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-[#193D6D] text-[#FCD34D] hover:bg-[#193D6D]/80',
        secondary:
          'border-transparent bg-[#FCD34D] text-[#193D6D] hover:bg-[#FCD34D]/80',
        destructive:
          'border-transparent bg-red-500 text-white hover:bg-red-500/80',
        outline: 'text-[#193D6D] border-[#193D6D]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };